import { render, staticRenderFns } from "./JoinDetail.vue?vue&type=template&id=6a5b903a&scoped=true&"
import script from "./JoinDetail.vue?vue&type=script&lang=js&"
export * from "./JoinDetail.vue?vue&type=script&lang=js&"
import style0 from "./JoinDetail.vue?vue&type=style&index=0&id=6a5b903a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5b903a",
  null
  
)

export default component.exports